import type { Reducer } from 'redux';
import { produce } from 'immer';
import { defaultState, Fields } from './DeleteMachineState';
import type { DeleteMachineActions } from './actions.types';
import DeleteMachineConstants from '~/domain/asset-details-common/components/DeleteMachine/constants';

const reducer: Reducer<Fields, DeleteMachineActions> = (state = defaultState, action) => {
  return produce<Fields>(state, (draft) => {
    switch (action.type) {
      case DeleteMachineConstants.CLOSE_DELETE_MACHINE_MODAL:
        return { ...defaultState };

      case DeleteMachineConstants.DELETE_MACHINE_REQUEST:
        draft.isLoading = true;
        delete draft.error;
        return draft;

      case DeleteMachineConstants.DELETE_MACHINE_REQUEST_SUCCESS:
        draft.isLoading = false;
        draft.isMachineDeleted = true;
        return draft;

      case DeleteMachineConstants.DELETE_MACHINE_REQUEST_ERROR:
        draft.isLoading = false;
        draft.isMachineDeleted = false;
        draft.error = action.error;
        return draft;

      case DeleteMachineConstants.OPEN_DELETE_MACHINE_MODAL:
        return {
          ...defaultState,
          isModalOpen: true,
          machineId: action.machineId,
          machineName: action.machineName,
          machineTags: action.machineTags ?? [],
        };

      default:
        return state;
    }
  });
};

export default reducer;
